/**
 * Contains all the data points related to premium domain option
 */

// Set isCore as true
// The premium is for paid user, we need to know what the user is doing and get enough logs to diagnostic issues
export default {
    DomainDashboardGetStarted: {
        datapoint: {
            name: 'DomainDashboardGetStarted',
            options: { isCore: true },
        },
    },
    DomainDashboardManageDomain: {
        datapoint: {
            name: 'DomainDashboardManageDomain',
            options: { isCore: true },
        },
    },
    DomainDashboardCreateEmail: {
        datapoint: {
            name: 'DomainDashboardCreateEmail',
            options: { isCore: true },
        },
    },
    DomainDashboardRemoveDomain: {
        datapoint: {
            name: 'DomainDashboardRemoveDomain',
            options: { isCore: true },
        },
    },
    DomainDashboarDomainStatus: {
        datapoint: {
            name: 'DomainDashboarDomainStatus',
            customData: (
                dnsValue: string,
                domainName: string,
                isDomainValid: boolean,
                isDomainExisted: boolean,
                purchaseType: string,
                purchaseDate: string
            ) => ({
                dnsValue: dnsValue,
                domainName: domainName,
                isDomainValid: isDomainValid,
                isDomainExisted: isDomainExisted,
                purchaseType: purchaseType,
                purchaseDate: purchaseDate,
            }),
            options: { isCore: true },
        },
    },
    DomainDashboarDomainUIStatus: {
        datapoint: {
            name: 'DomainDashboarDomainUIStatus',
            customData: (isAliasAdded: boolean, uiStatus: string) => ({
                isAliasAdded: isAliasAdded,
                uiStatus: uiStatus,
            }),
            options: { isCore: true },
        },
    },
    DomainDashboarRemoveSecondaryUserEmail: {
        datapoint: {
            name: 'DomainDashboarRemoveSecondaryUserEmail',
            options: { isCore: true },
        },
    },
};
